module.exports = __webpack_public_path__ + "static/09-2-f3a05f5a33d4d2e8f667b3231e6e4f1d.jpg";